
// redux
import { createListenerMiddleware, createSlice } from '@reduxjs/toolkit';
import { dispatch, getUserState } from '../store';
// @type
import { Application, User } from 'src/@type/management/user';

export type UserState = {
    //Actions
    getApplications: () => Promise<Application[]>
    getUsers: () => Promise<User[]>
    //Common
    isLoading: boolean
    error: string | null
    applications: Application[]

    users: User[]
    user: User | null
    //General
    isOpenUserForm: boolean
};

const initialState: UserState = {
    getApplications: () => new Promise<Application[]>(() => { }),
    getUsers: () => new Promise<User[]>(() => { }),
    isLoading: false,
    error: null,
    applications: [],
    users: [],
    user: null,
    isOpenUserForm: false
}

const slice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        // INIT
        init(state, action) {
            state.getApplications = action.payload.getApplications;
            state.getUsers = action.payload.getUsers;
        },
        // RESET
        reset(state) {
            state.isLoading = false;
            state.error = null;
            state.applications = [];
            state.users = [];
            state.user = null;
            state.isOpenUserForm = false;
        },
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // END LOADING
        endLoading(state) {
            state.isLoading = false;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        // SET APPLICATIONS
        setApplications(state, action) {
            state.applications = action.payload as Application[];
        },
        // SET USERS
        setUsers(state, action) {
            state.users = action.payload as User[]
        },
        // JHASDHSAHDJK
        selectUser(state, action) {
            state.user = action.payload as User | null;
        },
        // INSERT USER
        insertUser(state, action) {
            const user = action.payload as User;
            state.user = user;
        },
        // UPDATE USER
        updateUser(state, action) {
            const user = action.payload as User;
            state.user = user;
        },
        // OPEN USER FORM
        openUserForm(state) {
            state.isOpenUserForm = true;
        },
        // CLOSE USER FORM
        closeUserForm(state) {
            state.isOpenUserForm = false;
        }
    },
});

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
    predicate: (action, currentState, previousState) => {
        if (action.type && (action.type as string).startsWith(`${slice.name}/`)) {
            //const newState = (currentState as any).users as UserState;
            //const oldState = (previousState as any).urers as UserState;


            return action.type === 'users/setApplications' ||
                   action.type === 'users/insertUser' ||
                   action.type === 'users/updateUser'
        }
        return false;
    },
    effect: async (action, listenerApi) => {
        const state = (listenerApi.getState() as any).users as UserState;
        dispatch(updateUsers(state.getUsers));
    },
});

//ListenerMiddleware
export const usersListenerMiddleware = listenerMiddleware.middleware;

// Reducer
export default slice.reducer;

// Actions
// ----------------------------------------------------------------------
export function onLoadUsers() {
    dispatch(getBaseData());
}
// ----------------------------------------------------------------------
export function onUserSelect(user: User) {
    dispatch(slice.actions.selectUser(user));
}
// ----------------------------------------------------------------------
export function onUserInsert(user: User) {
    dispatch(slice.actions.insertUser(user));
}
// ----------------------------------------------------------------------
export function onUserChange(user: User) {
    dispatch(slice.actions.updateUser(user));
}
// ----------------------------------------------------------------------
export function onOpenUserForm() {
    dispatch(slice.actions.openUserForm());
}
// ----------------------------------------------------------------------
export function onCloseUserForm() {
    dispatch(slice.actions.closeUserForm());
}

// ----------------------------------------------------------------------
function getBaseData() {
    dispatch(slice.actions.reset());
    dispatch(slice.actions.startLoading());
    return async () => {
        try {
            (getUserState() as UserState).getApplications()
                .then((data) => {
                    dispatch(slice.actions.setApplications(data));
                }).catch((err) => {
                    dispatch(slice.actions.hasError(err));
                    dispatch(slice.actions.setApplications([]));
                });
        } catch (err) {
            dispatch(slice.actions.hasError(err));
        }
    }
}
// ----------------------------------------------------------------------
function updateUsers(getUsers: () => Promise<User[]>) {
    dispatch(slice.actions.startLoading());
    return async () => {
        try {
            getUsers().then((users: User[]) => {
                dispatch(slice.actions.hasError(undefined));
                dispatch(slice.actions.setUsers(users));
            }).catch((err: string) => {
                dispatch(slice.actions.hasError(err));
                dispatch(slice.actions.setUsers([]));
            });
        } catch (err) {
            dispatch(slice.actions.hasError(err));
        }
    }
}
// ----------------------------------------------------------------------
export function loadUserAction(getApplications: () => Promise<Application[]>, getUsers: () => Promise<User[]>) {
    dispatch(slice.actions.init({
        getApplications: getApplications,
        getUsers: getUsers
    }));
};
